import React, { Suspense, lazy, Fragment } from "react";
import { Spinner, Center } from "@chakra-ui/react";
import { Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "../components/layout/PublicLayout";

const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <Center h={window.innerHeight}>
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
        </Center>
      }
    >
      <Routes>
        {publicRoutes.map((route) => {
          const { Component, Layout, path, componentProps } = route;
          return (
            <Route
              path={path}
              element={
                <Layout>
                  <Component {...componentProps} />
                </Layout>
              }
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

const publicRoutes = [
  {
    path: "/",
    title: "Rental Marketplace",
    Layout: PublicLayout,
    Component: Navigate,
    componentProps: { to: "/rentalmarketplace" },
  },
  {
    path: "/lend",
    title: "Lend",
    Layout: PublicLayout,
    Component: lazy(() => import("../pages/Home")),
  },
  {
    path: "/lend/:loanId",
    title: "Lend details",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/LoanDetails")),
  },
  {
    path: "/trending",
    title: "Trending",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/Trending")),
  },
  {
    path: "/myloans",
    title: "Profile",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/MyLoans")),
  },
  {
    path: "/profile",
    title: "Profile",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/Profile")),
  },
  { 
    path: "/wallet",
    title: "wallet",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/WalletIndex"))
  },
  { 
    path: "/marketplace",
    title: "Marketplace",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/Marketplace"))
  },
  { 
    path: "/rentalmarketplace",
    title: "Rental Marketplace",
    Layout: PublicLayout,
    Component: lazy(() => import("./../pages/RentalMarketPlace"))
  }
];

export default AppRoutes;
